import React from 'react';

/******************************* helper functions *******************************/

const getStylyzeEventBus = () => window.StyEvents;

const isStylyzeAppOpen = () => {
  const stylyzeContainer = document.getElementById('stylyze-app');

  if (!stylyzeContainer) {
    return false;
  }

  return stylyzeContainer.children.length > 0;
};

const openStylyzeLandingPage = ({ stylyzeAccId, associatePin, associateEmail }) => {
  const StyEvents = getStylyzeEventBus();

  if (!StyEvents) {
    throw new Error('withStylyze: "StyEvents" global object isn\'t found');
  }

  StyEvents.emit('osp-stylist:init', {});
  StyEvents.emit('osp-stylist:landing-page', {
    accId: stylyzeAccId,
    stylistId: associatePin,
    stylistEmail: associateEmail,
  });
};

const closeStylyzeApp = () =>
  new Promise((resolve, reject) => {
    if (!isStylyzeAppOpen()) {
      return resolve(true);
    }

    const StyEvents = getStylyzeEventBus();

    if (!StyEvents) {
      reject(new Error('withStylyze: "StyEvents" global object isn\'t found'));
    }

    StyEvents.emit('osp-stylist:close-application', (success) => success && resolve(true));
  });

/******************************* END: helper functions *******************************/

/**
 * Pass helper functions to underlying component to communicate with Stylyze App
 * Stylyze App is rendered in `src/modules/looks/pages/LooksEmbedPage/LooksEmbedPage.js`
 *
 * @returns {function(*): function(*=, *): *}
 */
export const withStylyze = (Component) => {
  const StylyzeConsumer = (props) => {
    const newProps = { closeStylyzeApp, isStylyzeAppOpen, getStylyzeEventBus, openStylyzeLandingPage };

    return <Component {...newProps} {...props} />;
  };

  StylyzeConsumer.displayName = `StylyzeConsumer(${Component.displayName || Component.name})`;

  return StylyzeConsumer;
};

export default withStylyze;
